module.exports = __webpack_public_path__ + "img/uavfly-operator-bg.2bae1a19.jpg";